import script from "./DispatchOrderManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchOrderManagement.vue?vue&type=script&setup=true&lang=js"

import "./DispatchOrderManagement.vue?vue&type=style&index=0&id=7fb2fbb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb2fbb8"]])

export default __exports__